import { TITLE_TRIM_LENGTH } from '../common/constants';
import { DESCRIPTION_OFFSET, THREE_DOTS } from './constants';

export const stripHtml = (content: string) => {
  if (!content) return '';

  return (
    content
      // Replace <br>, <p>, <div> tags with newlines
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p\s*>/gi, '\n')
      .replace(/<\/div\s*>/gi, '\n')
      // Remove all HTML tags
      .replace(/<([^>]+)>/gi, '')
      // Replace HTML entities
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'")
      // Collapse multiple consecutive newlines to maximum of two
      .replace(/\n{3,}/g, '\n\n')
  );
};

/**
 * This function parses HTML content and extracts the text content.
 * @param htmlContent HTML content to be parsed
 * @returns The text content extracted from the HTML, including the new lines.
 */
export const parseHTML = (htmlContent: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const textContent = doc.body.textContent || '';

  return textContent?.trim();
};

export const extractFirstImageFromHtml = (content: string) => {
  const regex = /(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/gi;
  const resultArray = regex.exec(content);

  return resultArray ? resultArray[0] : null;
};

export const shortenString = (string: string, maxLength: number) => {
  return string.length > maxLength
    ? string.slice(0, maxLength) + THREE_DOTS
    : string;
};

export const getSearchContentShortened = (
  content: string,
  searchKey?: string,
  offset: number = DESCRIPTION_OFFSET
) => {
  if (!searchKey) {
    return content;
  }

  const searchStringIndex = content
    .toLocaleLowerCase()
    .indexOf(searchKey.toLocaleLowerCase());

  if (searchStringIndex > offset) {
    const text1 = content.slice(searchStringIndex - offset, searchStringIndex);
    const text2 = content.slice(
      searchStringIndex,
      searchStringIndex + searchKey.length + offset
    );
    return `${THREE_DOTS} ${text1}${text2} ${THREE_DOTS}`;
  }
  return (
    content.slice(0, offset * 2) +
    (offset * 2 < content.length ? THREE_DOTS : '')
  );
};

export const generateTitle = (title: string, contentHtml: string) => {
  const trimmedHtml = stripHtml(contentHtml).trim();

  return title && title !== ''
    ? title
    : trimmedHtml.length < TITLE_TRIM_LENGTH
    ? trimmedHtml
    : `${trimmedHtml.slice(0, TITLE_TRIM_LENGTH)}...`;
};

export const removeMultipleWhiteLinesAndSpaces = (text: string) => {
  // Remove consecutive multiple new lines and also consecutive nultiple white spaces
  let strippedText = text.replace(/(\r\n|\r|\n){2,}/g, '$1\n');
  strippedText = strippedText.replace(/ +/g, ' ').trim();

  return strippedText;
};
